import React, { useEffect, useState } from 'react';
import PropTypes                      from 'prop-types';

import ActorProfileCover      from './ActorProfileCover';
import ActorProfileDetails    from './ActorProfileDetails';
import ActorProfileNavigation from './ActorProfileNavigation';

import { openPicturesInViewer } from '../../Gallery/Viewer';
import { isObjectEmpty }        from '../../../utils/CommonUtils';
import Flux                     from '../../../flux/Flux';

const ActorProfileHeader = (props) => {

    const { actorData, isGuestLoggedIn, lineBreakPoint, routes, navigateTo, navigationRef } = props;
    
    const shouldLineBreak = () => (
        actorData.isOnline || actorData.isOnlineMobileVideocall
    ) && window.innerWidth < lineBreakPoint;

    const [lineBreak, setLineBreak] = useState(shouldLineBreak());
    const [serviceNumberItem, setServiceNumberItem] = useState(null);

    const handleWindowResize = () => {
        setLineBreak(shouldLineBreak());
    }

    const openViewer = (profileImage,e) => {
        e.preventDefault();

        if (profileImage.previewUrl) {
            openPicturesInViewer(
                'layer-album-modal', 
                [profileImage], 
                true, 
                0, 
                false, 
                true, 
                true, 
                { navigateTo: navigateTo, onOpenMediaViewer: () => {}, onCloseModalBox:   () => {},}
            );
        }
    }

    useEffect(()=>{
        if (actorData.serviceNumber0900) {
            const { countryCode }   = Flux.Guest.getGeoLocation();
            const serviceNumberItem = actorData.serviceNumber0900.find(item => item.country === countryCode);

            setServiceNumberItem(serviceNumberItem);
        }
    }, [actorData.serviceNumber0900])

    useEffect(()=> {
        window.addEventListener('resize', handleWindowResize);
        setLineBreak(shouldLineBreak());
        return () => {
            window.removeEventListener('resize', handleWindowResize)
        };
    }, [actorData.isOnline]);

    return (
        <div className="actor-profile-header" >
            <ActorProfileCover
                    actorId                 = {actorData.id}
                    actorName               = {actorData.name}
                    isDildocontrolAvailable = {actorData.isDildocontrolAvailable}
                    isGuestLoggedIn         = {isGuestLoggedIn}
                    isOnline                = {actorData.isOnline}
                    isPlaceholder           = {actorData.isPlaceholder}
                    isVoyeurChatAvailable   = {actorData.isVoyeurChatAvailable}
                    lineBreak               = {lineBreak}
                    openViewer              = {openViewer}
                    profileCoverPhotoUrl    = {actorData.headerPicture || actorData.coverPictureBig}
                    profileLink             = {actorData.profileLink}
                    isService0900Available  = {actorData.isService0900Available}
                    welcomeclip             = {actorData.welcomeclip}
            />
            <div className='actor-profile-header__footer'>
                <ActorProfileDetails 
                    actorData              = {actorData}
                    isService0900Available = {actorData.isService0900Available}
                    lineBreak              = {lineBreak}
                    openViewer             = {openViewer}
                    serviceNumberItem      = {serviceNumberItem}
                />
                {(routes && actorData.id) && <ActorProfileNavigation 
                    actorId              = {actorData.id}
                    isModelOnline        = {actorData.isOnline}
                    lastActiveRouteIndex = {props.lastActiveRouteIndex}
                    navigationRef        = {navigationRef}
                    routes               = {routes} 
                    scrollToBreadcrumbs  = {props.scrollToBreadcrumbs}
                />}
            </div>
        </div>
    )
}

ActorProfileHeader.propTypes = {
    actorData:        PropTypes.object.isRequired,
    isGuestLoggedIn:  PropTypes.bool.isRequired,
    routes:           PropTypes.object,
    navigationRef:    PropTypes.object.isRequired,
    navigateTo:       PropTypes.func.isRequired,
};

export default ActorProfileHeader;
